exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pageTitle__title___Nedsz {\n  padding: 12px 16px;\n  border: 1px solid #e8e8e8;\n  width: 100%;\n  margin: 0;\n  font-weight: 600; }\n", ""]);

// exports
exports.locals = {
	"title": "pageTitle__title___Nedsz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/PageTitle/pageTitle.scss
// module id = 1944
// module chunks = 6